module.exports = __webpack_public_path__ + "static/media/coppia.421f8439.jpeg";